import { useSystemStore } from "@/stores/system/SystemStore";
import ErrorHandler from "@/utilities/system/helpers/ErrorHandler";
import { ErrorLocationType } from "@/utilities/system/enums/Enums";
import { GeneralResponse } from "@/models/system/api/Responses";
import router from "@/router";
import {TokenService} from "@/utilities/system/services/TokenService";

/*
    check if user needs to reauthenticate and reroute path to login-page
*/
export default async function reactToRouting ({next}:any){
    const systemStore = useSystemStore();
    const tokenService = new TokenService();

    const token = await tokenService.GetAccessToken();
    const user = systemStore.user;

    const resp = new GeneralResponse();
    if(token === null || token === undefined || token.match(/^\w*$/) !== null) {
        resp.statusCode = 401;

        ErrorHandler.handleError(resp, ErrorLocationType.login);
    }
    else if(user === null || user === undefined) {
        resp.statusCode = 401;

        ErrorHandler.handleError(resp, ErrorLocationType.login);
    }

    //TODO make ANY small API call, that requires a token, to check refresh expiration
    //await (new MiscService()).getHubNotifications()

    return next();
}
